module.exports = __webpack_public_path__ + "static/media/pdf-gray.af5e7bc6.svg";